/**
 * getDonViCapDuoi: Hàm lấy danh sách đơn vị cấp dưới (vị dụ: Xã, phường)
 *
 * @param {*} maDonVi
 * @param {*} objectName là tên object dữ liệu trong reducer sẽ trả về
 */
export const getDonViCapDuoi = (apiCall, maDonVi, objectName) => {
  const configAPI = {
    urlData: 'api/dmdc/donvihanhchinhcapduoi',
    method: 'GET',
    value: null,
    apiType: 'LIST',
    params: {
      madonvi: maDonVi
    }
  };
  apiCall(configAPI, objectName);
};

/**
 * getDanhMucXa: Hàm lấy danh sách Xã, phường
 *
 * @param {*} maTinh
 * @param {*} maHuyen
 * @param {*} objectName là tên object dữ liệu trong reducer sẽ trả về
 */
export const getDanhMucXa = (apiCall, maTinh, maHuyen, objectName) => {
  const configAPI = {
    urlData: 'api/danhmucxas',
    method: 'GET',
    value: null,
    apiType: 'LIST',
    params: {
      maTinh,
      maHuyen
    }
  };
  apiCall(configAPI, objectName);
};

/**
 * getDanhMucThon: Hàm lấy danh sách thôn
 *
 * @param {*} maTinh
 * @param {*} maHuyen
 * @param {*} maXa
 * @param {*} objectName là tên object dữ liệu trong reducer sẽ trả về
 */
export const getDanhMucThon = (apiCall, maTinh, maHuyen, maXa, objectName) => {
  const configAPI = {
    urlData: 'api/danhmucthons',
    method: 'GET',
    value: null,
    apiType: 'LIST',
    params: {
      maTinh,
      maHuyen,
      maXa
    }
  };
  apiCall(configAPI, objectName);
};

// Hàm vừa lưu Redux vừa lưu localstorage
// getName là tên object dữ liệu trong reducer trả về, đồng thời là tên trong localStorage
export const apiSaveReduxLocal = {
  /**
   * getXaHuyenTinh: Hàm lấy danh sách xã, huyện, tỉnh
   * @param {function} apiCall
   * @param {string} getName là tên object dữ liệu trong reducer, đồng thời là tên lưu trong localStorage sẽ trả về
   */
  getListHuyen: (apiCall, getName) => {
    const configAPI = {
      urlData: 'api/danhmuchuyens?maTinh=49',
      method: 'GET',
      value: null,
      apiType: 'LIST',
      isSaveLocalStorage: true
    };
    apiCall(configAPI, getName);
  }
};
